<script>
    import { preventRedirectObj } from "../../stores";

    import { NotificationModal } from "./index.svelte";
</script>

<NotificationModal
    isModalOpen={$preventRedirectObj.showModal}
    showCancelBtn={false}
    title="Unsaved Changes"
    showConfirmBtn={false}
    btnOptions={$preventRedirectObj.btnOptions}
>
    <p class="text-error">{$preventRedirectObj.message}</p>
</NotificationModal>
